var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RequestIntersectionsWithPrimitiveCollisionShapeMessage, CollisionShapePrimitive, ResponseIntersectionsWithPrimitiveCollisionShapeMessage } from "@messages/selection";
import { convertToNumber3, convertToNumber4, FacetVisibility, ProximitySphere, UpdateFacetOnModelMessage } from "flavr-common";
const PROXIMITY_RADIUS_SCALE = 0.5;
export class ProximitySelect {
    constructor(connection, controllerUid, params) {
        var _a, _b;
        this.connection = connection;
        this.controllerUid = controllerUid;
        this.maxDistance = ((_a = params.maxLength) !== null && _a !== void 0 ? _a : 0.05) * PROXIMITY_RADIUS_SCALE;
        this.showSphere = (_b = params.showSphere) !== null && _b !== void 0 ? _b : true;
        if (this.showSphere) {
            this.connection.send(new UpdateFacetOnModelMessage(this.controllerUid, new ProximitySphere(this.maxDistance)));
        }
    }
    hide() {
        if (this.showSphere) {
            this.connection.send(new UpdateFacetOnModelMessage(this.controllerUid, new FacetVisibility(ProximitySphere, false)));
        }
    }
    show() {
        if (this.showSphere) {
            this.connection.send(new UpdateFacetOnModelMessage(this.controllerUid, new FacetVisibility(ProximitySphere, true)));
        }
    }
    canSelectionBeUpdated() {
        return true;
    }
    updateSelection(controllerPos, controllerOri, scale, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.connection.askByMessageType(new RequestIntersectionsWithPrimitiveCollisionShapeMessage(convertToNumber3(controllerPos), convertToNumber4(controllerOri), scale, CollisionShapePrimitive.SPHERE, this.maxDistance, undefined, true), ResponseIntersectionsWithPrimitiveCollisionShapeMessage);
                let minDist = this.maxDistance;
                let selection;
                for (const selectable of result.selectables) {
                    if (selectable.distance < minDist) {
                        minDist = selectable.distance;
                        selection = {
                            uid: selectable.uid,
                            hitPoint: selectable.worldPosition
                        };
                    }
                }
                callback(selection);
            }
            catch (error) {
                console.error(error);
            }
        });
    }
}
